import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap'
import {delinkUserOutlet} from '../../actions/outlet'
import Title from '../common/title'
import ConfirmPopup from '../common/confirm-popup';
import ArrowButton from '../common/button-arrow';
import no_photo from '../../assets/img/no_photo.png';
import {connect} from 'react-redux';

import './store-details.css'

class MyStore extends Component {

  constructor(props) {
    super(props);
    this.state = {
      smShow: false
    };
  }

  onDelinkClicked() {
    this.setState({smShow: true});
  }

  smClose = (result) => {
    if (result) {
      this
        .props
        .dispatch(delinkUserOutlet(this.props.storeId));
    }
    this.setState({smShow: false});
  };

  render() {
    const {store} = this.props;

    const representative = store.representative;
    let repImage = no_photo;
    try {
      if (representative["image"]) {
        repImage = representative["image"];
      }
    } catch (e) {
      repImage = no_photo;
    }

    return (
      <div className="store-details">
        <Row>
          <Col sm={6}>
            <h3>
              <div>
                <Title>{store.name || ''}</Title>
              </div>
            </h3>
            <h4 className='address-details'>
              <div>CUSTOMER NUMBER: {store["customer-number"] || ''}</div>
              <div>{store['address-2'] || ''}</div>
              <div>{store['address-3'] || ''}</div>
              <div>{store['address-1'] || ''}</div>
              <div>{store['town'] || ''}</div>
              <div>{store['county'] || ''}</div>
              <div>{store['eircode'] || ''}</div>
            </h4>
          </Col>
          <Col sm={6} className="rep-details">
            <h3 className="rep-title">Your rep</h3>
            <Row className="rep-image-and-name">
              <Col xs={5}>
                <img
                  src={repImage}
                  alt="Your rep"
                  className="rep-image"
                  onError={(e) => {
                    e.target.src = no_photo;
                  }}
                />
              </Col>
              <Col xs={7} className="rep-name-container">
                {representative && (
                  <div>
                    <div className="rep-name">
                      {(representative["rdr-first-name"] || "") + " " + (representative["rdr-last-name"] || "")}
                    </div>
                    <div>{representative["email"] || ""}</div>
                    <div>{representative["phone-number"] || ""}</div>
                  </div>
                )
                }
              </Col>
            </Row>
          </Col>

        </Row>
        <Row>
          <Col lg={12} className="remove-store-container">
            <ArrowButton
              submit={false}
              arrow={false}
              className="pull-right"
              onClick={() => this.onDelinkClicked()}>Remove store</ArrowButton>

            {this.state.smShow &&
            <ConfirmPopup onClose={this.smClose}>
              <p>
                Are you sure you want to remove this store from your
                <strong> ignite </strong>
                account? If you select confirm, your request will be sent to the
                <strong> ignite </strong>
                administration team.
              </p>
            </ConfirmPopup>
            }
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store
  };
};

export default connect(mapStateToProps)(MyStore);



// WEBPACK FOOTER //
// ./src/components/store-details/my-store.jsx